export default "__VITE_ASSET__Ca5r0$Gr__"